// store/index.js
import { createStore } from 'vuex';
import auth from './modules/auth';
import theme from './modules/theme';

export default createStore({
    state: {
        form: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            context: '',
            skills: []
        },
        initialForm: {}
    },
    mutations: {
        SET_FORM_FIELD(state, { field, value }) {
            state.form[field] = value;
        },
        SET_INITIAL_FORM(state, formData) {
            state.initialForm = JSON.parse(JSON.stringify(formData));
        },
        RESET_FORM(state) {
            state.form = JSON.parse(JSON.stringify(state.initialForm));
        }
    },
    getters: {
        isFormChanged(state) {
            return JSON.stringify(state.form) !== JSON.stringify(state.initialForm);
        }
    },
    actions: {
        initializeForm({ commit }, formData) {
            commit('SET_INITIAL_FORM', formData);
        },
        resetForm({ commit }) {
            commit('RESET_FORM');
        },
        updateFormField({ commit }, payload) {
            commit('SET_FORM_FIELD', payload);
        }
    },
    modules: {
        auth,
        theme,
    }
});
